import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { GetVoucherTypesApi, SearchVoucherApi } from "./VoucherAction";
import { Link } from "react-router-dom";
import { setHeading } from "../../../accounts/account.actions";
import { getUserRes } from "../../AddUser/user.actions";
import _ from "lodash";
import Select from 'react-select';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import { GlobalSpinner } from "../../../../../global/globalFunctions";


const VoucherSearch = (props) => {
    const [voucherTypeId, setVoucherTypeId] = useState("");
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [status, setStatus] = useState();
    const [createdUserId, setCreatedUserId] = useState();
    const [approveUserId, setApproveUserId] = useState();

    const SearchData = () => {
        props.SearchVoucherApi({
            startedDate: _.isEmpty(startDate) ? "" : startDate,
            endDate: _.isEmpty(endDate) ? "" : endDate,
            voucherTypeId: voucherTypeId,
            status: status ? status : [],
            createdUserId: createdUserId,
            approveUserId: approveUserId,
        });
    };

    const voucherData = !_.isEmpty(props.voucherTypeList) && props.voucherTypeList.map((x) => {
        let data = {
            value: x._id,
            accType: x.voucherTypeId,
            label: x.voucherType
        };
        return data
    });
    const handleVoucher = (selectedOption) => {
        setVoucherTypeId(selectedOption.accType);
    };

    let statusData = [{
        id: "Pending",
        type: "Pending",
    },
    {
        id: "Approved",
        type: "Approved",
    },
    {
        id: "Disapproved",
        type: "Disapproved",
    }];
    const handleChangeStatus = (selectedOption) => {
        setStatus(selectedOption.map(obj => obj.label));
    };
    const GetStatusList = statusData.map((x) => {
        let data = { value: x.id, label: x.type };
        return data;
    });

    const GetCreatedUserList = !_.isEmpty(props.userList) && props.userList.map((x) => {
        let data = { value: x._id, label: x.userName };
        return data;
    });
    const handleChangCreatedUser = (selectedOption) => {
        setCreatedUserId(selectedOption.value);
    };

    const GetApproveUserList = !_.isEmpty(props.userList) && props.userList.map((x) => {
        let data = { value: x._id, label: x.userName };
        return data;
    });
    const handleChangeApproveUser = (selectedOption) => {
        setApproveUserId(selectedOption.value);
    };

    useEffect(() => {
        props.GetVoucherTypesApi();
        props.getUserRes();
        props.setHeading("Voucher Search");
    }, []);

    return (
        <>
            {props.isFetchingVoucherTypes || props.isFetchingUser ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" >
                                <Form.Label><b>Start Date</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    onChange={(e) => setStartDate(e.target.value)}
                                    value={startDate}>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" >
                                <Form.Label><b>End Date</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    onChange={(e) => setEndDate(e.target.value)}
                                    value={endDate}
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" >
                                <Form.Label><b>Select Voucher Type *</b></Form.Label>
                                <Select
                                    placeholder="Select Voucher Type"
                                    onChange={handleVoucher}
                                    options={voucherData}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" >
                                <Form.Label><b>Select Status</b></Form.Label>
                                <Select
                                    placeholder="Select Status"
                                    onChange={handleChangeStatus}
                                    options={GetStatusList}
                                    isMulti={true}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" >
                                <Form.Label><b>Select Created User</b></Form.Label>
                                <Select
                                    placeholder="Select Created User"
                                    onChange={handleChangCreatedUser}
                                    options={GetCreatedUserList}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" >
                                <Form.Label><b>Select Approvel User</b></Form.Label>
                                <Select
                                    placeholder="Select Approvel User"
                                    onChange={handleChangeApproveUser}
                                    options={GetApproveUserList}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="sendDiv">
                        {voucherTypeId === "" ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SEARCH </Button>
                        ) : (
                            <Link to="/accountsModule/Voucher/VoucherSearchDetails">
                                <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SearchData}> SEARCH </Button>
                            </Link>
                        )}
                    </div>

                </Container>
            )}
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        GetVoucherTypesApi: () => dispatch(GetVoucherTypesApi()),
        SearchVoucherApi: (data) => dispatch(SearchVoucherApi(data)),
        getUserRes: () => dispatch(getUserRes()),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    voucherTypeList: state.VouchersReducer.voucherTypeList,
    isFetchingVoucherTypes: state.VouchersReducer.isFetchingVoucherTypes,
    userList: state.UserReducer.userList,
    isFetchingUser: state.UserReducer.isFetchingUser,
});

export default connect(mapStateToProps, mapDispatchToProps)(VoucherSearch);